(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuori-preview-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-vhr-categories]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-vhr-category-tab]')];
    const panels = [...root.querySelectorAll('[data-vhr-category-panel]')];
    root.querySelectorAll('[data-vhr-category-next]').forEach((button) => button.addEventListener('click', () => {
      button.previousElementSibling?.scrollBy({left: button.previousElementSibling.clientWidth * .82, behavior: 'smooth'});
    }));
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const audience = tab.dataset.vhrCategoryTab;
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      panels.forEach((panel) => panel.classList.toggle('is-hidden', panel.dataset.vhrCategoryPanel !== audience));
    }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuori-preview-footer"] && !Shopify.designMode) return;
  try {
    
  const footerViewport = window.matchMedia('(max-width: 749px)');
  function setFooterGroups() {
    document.querySelectorAll('.vhr-footer__group').forEach(group => {
      group.open = !footerViewport.matches;
    });
  }
  setFooterGroups();
  footerViewport.addEventListener('change', setFooterGroups);
  document.addEventListener('shopify:section:load', setFooterGroups);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuori-preview-header-utility"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vhr-newsletter-link]').forEach(link => {
    link.addEventListener('click', event => {
      const destination = new URL(link.href);
      if (destination.origin !== window.location.origin || !destination.hash) return;
      const target = document.getElementById(destination.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior: 'smooth', block: 'center'});
      target.querySelector('input[type=email]')?.focus({preventScroll: true});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuori-preview-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-vhr-hero]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-vhr-slide]')];
    const dots = [...root.querySelectorAll('[data-vhr-dot]')];
    let current = 0;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === current));
    };
    root.querySelector('[data-vhr-prev]')?.addEventListener('click', () => show(current - 1));
    root.querySelector('[data-vhr-next]')?.addEventListener('click', () => show(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    if (slides.length > 1) window.setInterval(() => show(current + 1), 6000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuori-preview-link-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-vhr-link-carousel]').forEach(root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-vhr-link-tab]')];
    const panels = [...root.querySelectorAll('[data-vhr-link-panel]')];
    root.querySelectorAll('[data-vhr-link-next]').forEach((button) => button.addEventListener('click', () => {
      button.previousElementSibling?.scrollBy({left: button.previousElementSibling.clientWidth * .82, behavior: 'smooth'});
    }));
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const audience = tab.dataset.vhrLinkTab;
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      panels.forEach((panel) => panel.classList.toggle('is-hidden', panel.dataset.vhrLinkPanel !== audience));
    }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vuori-preview-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-vhr-products]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-vhr-products-track]');
    const next = root.querySelector('[data-vhr-products-next]');
    next?.addEventListener('click', () => track?.scrollBy({left: track.clientWidth * .82, behavior: 'smooth'}));
  })();

  } catch(e) { console.error(e); }
})();
})();
